<template>
  <div>
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-data-table
          v-model="periodoVac"
          :headers="header"
          :items="periodos"
          show-select
          single-select
          item-key="idPeriodoVacaciones"
          dense
          :items-per-page="10"
          :hide-default-footer="hideFooter"
          :loading="loading"
          loading-text="Cargando datos..."
          class="elevation-2"
        >
          <template v-slot:top>
            <v-row class="mx-6">
              <v-col cols="2">
                <v-select label="Unidad" v-model="uniEje" :items="unidades" dense
                  item-text="texto" item-value="value"></v-select>
              </v-col>
              <v-col cols="2">
                <v-select label="Ambito" v-model="ambito" :items="ambitos" dense
                  item-text="texto" item-value="value"></v-select>
              </v-col>
              <v-col cols="2">
                <v-select label="Coord. Estatal" v-model="coordEst" :items="coordsEst" dense
                  item-text="texto" item-value="value"></v-select>
              </v-col>
              <v-col cols="2">
                <v-select label="Ejercicio" v-model="ejercicio" :items="ejercicios" dense></v-select>
              </v-col>
              <v-col cols="4">
                <v-row class="justify-space-between">
                  <div style="display: inline-block">
                    <v-tooltip bottom activator="#btn-reload">
                      <span>Cargar</span>
                    </v-tooltip>
                    <v-btn id="btn-reload" icon @click="loadVacExtra()">
                      <v-icon >mdi-refresh</v-icon>
                    </v-btn>
                  </div>
                  <div style="display: inline-block">
                    <v-tooltip bottom activator="#btn-add">
                      <span>Agregar</span>
                    </v-tooltip>
                    <v-btn id="btn-add" icon @click="showDlgAdd=true">
                      <v-icon >mdi-account-plus-outline</v-icon>
                    </v-btn>
                    <v-tooltip bottom activator="#btn-remove">
                      <span>Quitar</span>
                    </v-tooltip>
                    <v-btn id="btn-remove" icon @click="cancelaExtra">
                      <v-icon>mdi-account-remove-outline</v-icon>
                    </v-btn>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="showDlgAdd" persistent max-width="500">
      <v-card flat class="pa-0">
        <v-card-title class="pa-0 primary white--text justify-space-between">
            <span class="text-h6 ml-2">Registrar vacaciones extraordinarias</span>
            <span class="mr-2">
              <v-btn color="white" icon @click="showDlgAdd = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-progress-linear :active="loadingAdd" indeterminate></v-progress-linear>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="9">
              <buscar-empleado :value.sync="empleado"></buscar-empleado>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span>{{nombreEmpleado}}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-alert v-if="added" v-model="alert" outlined type="success" dense>
                {{mensajeAdd}}
              </v-alert>
              <v-alert v-else v-model="alert" outlined type="error" dense>
                {{mensajeAdd}}
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="py-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn id="btn-close" color="primary" text @click="showDlgAdd = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <dialog-message :show.sync="showDialog" :color="colorDlg" :title="titleDlg">
      {{ mensaje }}
    </dialog-message>

    <dialog-confirmar :show="showDlgConfirmar" @selected="onConfirmar($event)">
      {{ mensaje }}
    </dialog-confirmar>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import DialogMessage from "@/components/dialogs/DialogMessage.vue";
import DialogConfirmar from "@/components/dialogs/DialogConfirmar.vue";
import BuscarEmpleado from '@/components/dialogs/BuscarEmpleado.vue';
import AccesosUtils from "@/utils/AccesosUtils.js";

export default {
  components: {
    DialogMessage,
    DialogConfirmar,
    BuscarEmpleado
  },
  data() {
    return {
      accesosUtils: new AccesosUtils(),
      ejercicio: null,
      uniEje: null,
      coordEst: null,
      ambito: null,
      ejercicios: [],
      unidades: [],
      coordsEst: [],
      ambitos: [],
      empleado: null,
      nombreEmpleado: "",
      periodos: [],
      header: [
        { text: 'Nombre', value: 'nombre', class: "accent white--text"},
        { text: 'Dias extra', value: 'diasExtra', class: "accent white--text"},
        { text: 'Disfrutados', value: 'disfExtra', class: "accent white--text"}
      ],
      periodoVac: [],
      loading: false,
      loadingAdd: false,
      showDlgAdd: false,
      showDialog: false,
      showDlgConfirmar: false,
      colorDlg: "primary",
      titleDlg: "",
      mensaje: null,
      overlay: false,
      mensajeAdd: "",
      added: true,
      alert: false,
      styleAdd: "",
      inicializado: false,
      observer: false
    }
  },
  computed: {
    hideFooter() {
      return this.periodos.length < 10;
    },
    ...mapState(["usuario"]),
  },
  watch: {
    empleado() {
      if (this.empleado) {
        this.nombreEmpleado = this.empleado.nombres+ " "+ this.empleado.apellidoPat+ " "+ this.empleado.apellidoMat;
        this.loadVacExtraEmp();
      }
    },
    uniEje() {
      if (this.inicializado && this.uniEje && this.observer) {
        this.updateAmbitos();
      }
    },
    ambito() {
      if (this.inicializado && this.observer) {
        this.updateCoordEst();
      }
    }
  },
  methods: {
    async loadAccesos() {
      let self = this;
      await this.accesosUtils.loadAccesos(this.usuario, (unidades, ambitos, ces) => {
        self.observer = false;
        self.unidades = unidades;
        self.ambitos = ambitos;
        self.coordsEst = ces;
        self.observer = true;
      });
      return "";
    },
    updateAmbitos() {
      let self = this;
      this.accesosUtils.loadAccesosUniEje(this.uniEje, (ambitos, ces) => {
        self.observer = false;
        self.ambitos = ambitos;
        if (ambitos && ambitos.length > 0) {
          self.ambito = ambitos[0].value;
        }
        self.coordsEst = ces;
        if (ces && ces.length > 0) {
          self.coordEst = ces[0].value;
        }
        self.observer = true;
      });
    },
    updateCoordEst() {
      let self = this;
      this.accesosUtils.loadAccesosAmb(this.uniEje, this.ambito, (ces) => {
        self.coordsEst = ces;
        if (ces && ces.length > 0) {
          self.coordEst = ces[0].value;
        }
      });
    },
    async loadVacExtra() {
      let self = this;
      this.loading = true;
      try {
        const response = await axios.get(`/vacaciones/extra?ejer=${this.ejercicio}&uniEje=${this.uniEje}&ce=${this.coordEst}&amb=${this.ambito}`);
        self.periodos = response.data;
        self.loading = false;
        return "";
      }catch(error) {
        self.loading = false;
        if (error.response) {
          self.showError(error.response.data);
        } else {
          console.log(error);
          self.showError("No se pudo ejecutar la petición.")
        }
        return "";
      }
    },
    loadVacExtraEmp() {
      let self = this;
      this.loadingAdd = true;
      let numEmp = this.empleado.numEmpleado;
      axios.get(`/vacaciones/extra/empleado?emp=${numEmp}&ejer=${this.ejercicio}&ce=${this.coordEst}&amb=${this.ambito}`)
      .then(response => {
        self.loadingAdd = false;
        self.empleado = null;
        self.periodos.push(response.data);
        self.showAdded();
      })
      .catch(error => {
        self.loadingAdd = false;
        self.empleado = null;
        if (error.response) {
          self.showNoAdded(error.response.data);
        } else {
          console.log(error);
          self.showNoAdded("No se pudo ejecutar la petición.")
        }
      });
    },
    cancela() {
      let id = this.periodoVac[0].idPeriodoVacaciones;
      this.loading = true;
      let self = this;
      axios.delete(`/vacaciones/extra/${id}`)
      .then(response => {
        self.loading = false;
        let pers = self.periodos.filter(pv => pv.idPeriodoVacaciones !== id);
        self.periodos = pers;
        self.showInfo(response.data);
      })
      .catch(error => {
        self.loading = false;
        if (error.response) {
          self.showError(error.response.data);
        } else {
          console.log(error);
          self.showError("No se pudo ejecutar la petición.")
        }
      });
    },
    cancelaExtra() {
      if (this.periodoVac && this.periodoVac.length > 0) {
        if (this.periodoVac[0].disfExtra === 0) {
          this.mensaje = "¿Quitar las vacaciones extraordinarias?";
          this.showDlgConfirmar = true;
        } else {
          this.showError("No se puede eliminar, ya disfrutó de las vacaciones.");
        }
      } else {
        this.showWarning("No hay periodo seleccionado.")
      }
    },
    onConfirmar(value) {
      this.showDlgConfirmar = false;
      if (value) {
        this.cancela();
      }
    },
    showError: function (message) {
      this.mensaje = message;
      this.colorDlg = "error";
      this.titleDlg = "Error",
      this.showDialog = true;
    },
    showWarning: function (message) {
      this.mensaje = message;
      this.colorDlg = "accent";
      this.titleDlg = "Revisar",
      this.showDialog = true;
    },
    showInfo: function (message) {
      this.mensaje = message;
      this.colorDlg = "primary";
      this.titleDlg = "Aviso",
      this.showDialog = true;
    },
    showAdded() {
      this.mensajeAdd = "Se registaron las vacaciones extraordinarias."
      this.added = true;
      this.alert = true;
      this.hideMessage();
    },
    showNoAdded(mensaje) {
      this.added = false;
      this.mensajeAdd = mensaje;
      this.alert = true;
      this.hideMessage();
    },
    hideMessage() {
      let self = this;
      setTimeout(() => {
        self.mensajeAdd = "";
        self.alert = false;
      }, 4000);
    },
    async init() {
      let v = await this.loadVacExtra();
      await this.loadAccesos(v);
      this.inicializado = true;
    }
  },
  mounted: function() {
    let fecha = new Date();
    this.ejercicios.push(fecha.getFullYear());
    this.ejercicio = fecha.getFullYear();
    this.uniEje = this.usuario.unidadEjecutora;
    this.ambito = this.usuario.ambito;
    this.coordEst = this.usuario.coordEstatal.toString();
    this.init();
  }
}
</script>

<style scoped>
  .no-added {
    color: red;
  }
</style>